<template>
    <div>
        <h5>Manage Appliances</h5>
        <div>
            <Toolbar v-if="authStore.hasPermission(UserPermission.WRITE_CALLSIGN)" class="mb-4 card">
                <template v-slot:start>
                    <div class="my-2">
                        <Button label="Create Appliance" icon="pi pi-plus" class="p-button-success mr-2" @click="dialogForm = true" />
                    </div>
                </template>
                <template v-slot:end>
                    <div class="my-2">
                        <csv-parser @json-created="loadApplianceJson" />
                        <ScaleLoader v-if="uploadingCsv" class="mx-auto" />
                    </div>
                </template>
            </Toolbar>

            <!-- create Appliance form -->
            <appliance-form v-if="dialogForm" @hide-dialog="dialogForm = false" />

            <!-- Appliance table -->
            <appliance-table />
        </div>
    </div>
</template>
<script setup>
import ApplianceTable from '../modules/ApplianceTable.vue';
import ApplianceForm from '../modules/ApplianceForm.vue';
import CsvParser from '../../../../../components/CsvParser.vue';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { applianceStore, authStore } from '../../../../../store/global-stores';
import { UserPermission } from '../../../../../modules/permission/enum';

const dialogForm = ref(false);
const uploadingCsv = ref(false);
const { company_id } = storeToRefs(applianceStore);

const loadApplianceJson = async (jsonData) => {
    const applianceJsonData = jsonData?.map((obj) => {
        return {
            name: obj.name,
            company_id: company_id.value,
        };
    });
    uploadingCsv.value = true;
    await applianceStore.addApplianceFromJson(applianceJsonData);
    uploadingCsv.value = false;
};
</script>
